import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppStoreModel, APP_STATE_TOKEN, ROUTES_URL } from '@app/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-section-footer',
  templateUrl: './section-footer.component.html',
  styleUrls: ['./section-footer.component.scss']
})
export class SectionFooterComponent implements OnInit {

  // @Select(APP_STATE_TOKEN) appState$: Observable<AppStoreModel>;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  handleClickRouteAbout = () => {

    const url = this.router.serializeUrl(
      this.router.createUrlTree([ROUTES_URL.ABOUT])
    );

    window.open(url, '_blank');

  }

  handleClickRoutePaginaInformativa = () => {

    const url = this.router.serializeUrl(
      this.router.createUrlTree([ROUTES_URL.INFORMACION_COMUNIDAD])
    );

    window.open(url, '_blank');
  }
}
